import type {ComponentPropsWithoutRef} from 'react';
import {clsx} from 'clsx';
import styles from './link.module.css';

type Props = Omit<ComponentPropsWithoutRef<'a'>, 'href' | 'target' | 'rel'> & {
  readonly to: string;
  readonly isExternal?: boolean;
};

export function Link({
  children,
  isExternal = false,
  to,
  className,
  ...props
}: Props) {
  return (
    <a
      {...props}
      className={clsx(styles.link, className)}
      href={to}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noreferrer noopener' : undefined}
    >
      {children}
    </a>
  );
}
